import React, { useState } from 'react';
import { Translate } from 'react-localize-redux';
import useInterval from '@use-it/interval';
import Img from 'gatsby-image';
import styled, { css } from 'styled-components';

import { glitch, noise1, noise2, stopRotate } from './keyframes';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - 3.5rem - 2.5em);
  overflow: hidden;
  position: relative;
  transform: translateY(-1.75rem);

  @media (min-width: 768px) {
    margin: 0 auto;
    max-width: 1200px;
  }
`;

const BackgroundContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  perspective: 60em;
`;

const Background = styled(Img)`
  animation: ${stopRotate} 4s 3s ease infinite;
  display: block;
  max-width: 88%;
  width: 25em;

  @media (min-width: 768px) {
    width: 30em;
  }
`;

const ImageContainer = styled.h1`
  font-size: 1em;
  margin: 2em 0 0;
  max-width: 90%;
  position: relative;
  width: 25em;

  @media (min-width: 768px) {
    width: 30em;
  }

  ${({ active, logo }) =>
    active &&
    css`
      animation: ${glitch} 1s linear;

      &::before {
        content: '';
        position: absolute;
        background: url(${logo}) 0 0 /100% no-repeat;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        clip: rect(0, 900px, 0, 0);
        filter: drop-shadow(2px 2px 2px rgba(35, 184, 197, 1));
        animation: ${noise1} 0.5s linear alternate-reverse;
        opacity: 0.8;
      }

      &::after {
        content: '';
        position: absolute;
        background: url(${logo}) 0 0 /100% no-repeat;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        clip: rect(0, 900px, 0, 0);
        filter: drop-shadow(2px 2px 2px rgba(274, 27, 27, 1));
        animation: ${noise2} 1s linear alternate-reverse;
        opacity: 0.8;
      }
    `}
`;

const Image = styled(Img)`
  display: block;
  width: 100%;
`;

const InfoContainer = styled.div`
  margin: 2em 0 8em;
  z-index: 1;
`;

const Info = styled.div`
  outline: 1px solid #ffffff;
  border: 1px solid transparent;
  display: flex;
  font-family: 'Noto Serif JP', serif;
  justify-content: center;

  > span {
    padding: 0.4em 0.8em;
  }

  > span:first-child {
    background: #ffffff;
    color: #111111;
  }

  > span:last-child {
    background: #111111;
    color: #ffffff;
  }
`;

const KeyVisual = ({ onLoad, data }) => {
  const [active, setActive] = useState(false);

  useInterval(() => {
    setActive(val => !val);
  }, 2000);
  return (
    <Container>
      <BackgroundContainer>
        <Background
          fluid={data.ministry.childImageSharp.fluid}
          onLoad={onLoad}
        />
      </BackgroundContainer>
      <ImageContainer
        active={active}
        logo={data.logo.childImageSharp.fluid.src}
      >
        <Translate>
          {({ translate }) => (
            <Image
              alt={translate('landingPage.games.3.title')}
              fluid={data.logo.childImageSharp.fluid}
              onLoad={onLoad}
            />
          )}
        </Translate>
      </ImageContainer>
      <InfoContainer>
        <Info>
          <span>
            <Translate id="psyLandingPage.keyVisual.info.1" />
          </span>
          <span>
            <Translate id="psyLandingPage.keyVisual.info.2" />
          </span>
        </Info>
      </InfoContainer>
    </Container>
  );
};

export default KeyVisual;
